import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "goods_show"
};
const _hoisted_2 = {
  class: "goods_txt"
};
const _hoisted_3 = {
  class: "goods_info"
};
const _hoisted_4 = {
  class: "goods_buy"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "cart_btn"
};
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_stepper = _resolveComponent("van-stepper");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_van_nav_bar, {
      title: "产品搜索",
      "left-arrow": "",
      onClickLeft: $setup.goBack
    }, null, 8, ["onClickLeft"]), _createVNode(_component_van_search, {
      modelValue: $setup.keywords,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.keywords = $event),
      placeholder: "请输入搜索关键词",
      onSearch: $setup.goSearch
    }, null, 8, ["modelValue", "onSearch"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
    finished: $setup.finished,
    "finished-text": "没有更多了",
    onLoad: $setup.loadData
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "goods_list",
        key: key
      }, [_createElementVNode("div", {
        class: "goods_img",
        style: _normalizeStyle("background-image: url(" + item.img + ");")
      }, [_createVNode(_component_router_link, {
        to: "/goods/show?id=" + item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["to"])], 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("dl", _hoisted_3, [_createElementVNode("dt", null, _toDisplayString(item.name), 1), _createElementVNode("dd", null, "规格：" + _toDisplayString(item.spec), 1), _createElementVNode("dd", null, "保质期：" + _toDisplayString(item.quality), 1)]), _createElementVNode("dl", _hoisted_4, [_createElementVNode("dt", null, [_createElementVNode("span", null, "￥" + _toDisplayString(item.price) + "/" + _toDisplayString(item.unit), 1)]), $setup.cartList[item.id] ? (_openBlock(), _createElementBlock("dd", _hoisted_5, [_createVNode(_component_van_stepper, {
        modelValue: $setup.cartList[item.id].count,
        "onUpdate:modelValue": $event => $setup.cartList[item.id].count = $event,
        step: item.step_no,
        min: "0",
        name: item.id,
        onChange: $setup.editCart,
        onMinus: $event => $setup.delCart(item.id, item.less_no),
        "disable-input": ""
      }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "name", "onChange", "onMinus"])])) : (_openBlock(), _createElementBlock("dd", _hoisted_6, [_createElementVNode("button", {
        onClick: $event => $setup.addCart(item.id, item.less_no)
      }, "加入购物车", 8, _hoisted_7)]))])])]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])])], 64);
}